import { Directive, Input, OnInit } from '@angular/core';

export interface ICakeBuilderLink {
  link: string;
  queryParams: { [key: string]: any } | null;
}

/** `'/path?a=1&b=2'` → `{ link: '/path', queryParams: { a: '1', b: '2' } }` for `[routerLink]` + `[queryParams]`. */
export function parseCakeBuilderUrl(url: string): ICakeBuilderLink | null {
  if (!url) {
    return null;
  }

  const [link, paramsStr] = url.split('?');
  const queryParams = paramsStr
    ? paramsStr.split('&')
      .reduce((res, param) => {
        const [key, val] = param.split('=');
        res[key] = val;
        return res;
      }, {})
    : null;

  return { link, queryParams };
}

@Directive({ standalone: false })
export class CakeBuilderLink implements OnInit {
  @Input() productTypeBuilderUrl: string;

  public builderLink: string;
  public builderLinkQueryParams: { [key: string]: any };

  ngOnInit() {
    const parsed = parseCakeBuilderUrl(this.productTypeBuilderUrl);

    if (parsed) {
      this.builderLink = parsed.link;
      this.builderLinkQueryParams = parsed.queryParams;
    }
  }
}
